import { writable } from 'svelte/store'
import { fetchWithSession } from '../util/fetchWithSession'

export function createFiltersConfigStore() {
  const { subscribe, set, update } = writable({
    filtersConfig: [],
    filterAllowedOperators: [],
    filterColumnDefinitions: [],
    filterDefinitions: [],
    filterOperators: [],
    views: [],
    processFlowSteps: [],
    windowtitles: [],
    clearnames: [],
    applicationnames: [],
    currentView: null,
    valueFilters: {},
    dataTypesWithTitles: {},
    storeLoaded: false,
    tab: null,
  });

  async function getFiltersConfig(analysisId) {
    try {
      const res = await fetchWithSession(`/api/analysis/getGuiPresets/${analysisId}`);
      const data = await res.json();
      update(state => ({
        ...state,
        filtersConfig: data,
        filterAllowedOperators: data.filterAllowedOperators,
        filterColumnDefinitions: data.filterColumnDefinitions,
        filterDefinitions: data.filterDefinitions,
        filterOperators: data.filterOperators,
        views: data.views,
        processFlowSteps: data.filterColumnDefinitions.activity.values,
        windowtitles: data.filterColumnDefinitions.windowtitle.values,
        clearnames: data.filterColumnDefinitions.clearname.values,
        applicationnames: data.filterColumnDefinitions.applicationname.values,
        valueFilters: mergeColumnDefinitions(data.filterDefinitions.value, data.filterColumnDefinitions),
        dataTypesWithTitles: combineDataTypesWithTitles(data.filterAllowedOperators, data.filterOperators),
        storeLoaded: true,
      }));
    } catch (err) {
      console.log(err);
    }
  }

  function getFilterByCurrentView(views, filterDefinitions, filterColumnDefinitions, filterAllowedOperators, filterOperators, currentView, tab) {
    const filterByTab = tab && views[currentView]?.tabs[tab]
    const filters = !filterByTab ? views[currentView].filters : filterByTab.filters;
    const viewFilters = [];
    for (let filter of filters) {
      const filterDefinition = filterDefinitions[filter];
      if (!filterDefinition) continue;  // Skip if no filter definition found

      let processSteps = null;
      if (filterDefinition.valuesFromColumn) {
        processSteps = filterColumnDefinitions[filterDefinition.valuesFromColumn]?.values;
      }

      const columns = filterDefinition.columns || [];
      const filterDetails = columns.map(column => {
        const columnDefinition = filterColumnDefinitions[column];
        if (!columnDefinition) return null;
        
        const datatype = columnDefinition.datatype;
        const allowedOperators = filterAllowedOperators[datatype] || [];

        const allowedOperatorsWithTitles = allowedOperators.map(operator => {
          const operatorDefinition = filterOperators[operator];
          return operatorDefinition ? { operator, title: operatorDefinition.title } : { operator, title: '' };
        });
        return {
          column,
          title: columnDefinition.title,
          datatype,
          allowedOperators: allowedOperatorsWithTitles,
          values: columnDefinition.values || null,
          columns: columnDefinition.columns || null,
        };
      }).filter(Boolean);
      viewFilters.push({
        filterKey: filter,
        title: filterDefinition.title,
        type: filterDefinition.type,
        filterDetails,
        processSteps
      });
    }

    return viewFilters;
  }

  function setCurrentView(view, tab) {
    update(state => {
      return {
        ...state, 
        currentView: view,
        tab: tab ? tab : null,
      };
    });
  }

  function mergeColumnDefinitions(value, filterColumnDefinitions) {
    return value.columns.reduce((acc, column) => {
        acc[column] = filterColumnDefinitions[column] || { title: column, datatype: "unknown" };
        return acc;
    }, {});
  }

  function combineDataTypesWithTitles(dataTypes, operators) {
    const result = {};

    for (const datatype in dataTypes) {
        result[datatype] = dataTypes[datatype].map(operator => {
            return {
                operator: operator,
                title: operators[operator] ? operators[operator].title : operator
            };
        });
    }

    return result;
  }

  return {
    subscribe,
    getFiltersConfig,
    getFilterByCurrentView,
    setCurrentView,
    mergeColumnDefinitions,
    combineDataTypesWithTitles
  };
}

export const filtersConfigStore = createFiltersConfigStore();
